/*@ngInject*/
const FormSnippetsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getFormSnippets = function (rootFormId) {
        let url = '/rest/Form/' + rootFormId + '/snippets';

        return this.get(url);
    };
};

angular.module('umFormViewer')
    .service('formSnippetsRepository', FormSnippetsRepository);
